import script from "./id-3d.vue?vue&type=script&setup=true&lang=js"
export * from "./id-3d.vue?vue&type=script&setup=true&lang=js"

import "./id-3d.vue?vue&type=style&index=0&id=d24935bc&lang=css"

const __exports__ = script;

export default __exports__